import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./footerQuestionIndex.scss";
import { ExamQuestion } from "./types";
import { imagesUrl } from "./utils";

interface onChangeProps {
  onChange: (questionId: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onToggle: (state: any) => void;
  data: ExamQuestion[] | undefined;
}

const FooterQuestionIndex = ({ data, onChange, onToggle }: onChangeProps) => {
  const gotoTargetedQuestion = (qIndex: string) => {
    onChange(qIndex);
    onToggle(false);
  };

  return (
    <div className="footerQuestionIndex">
      <div className="indexHeader">
        <div className="keys">
          <div className="key">
            <div className="box"></div>
            <p className="label">Not Answered</p>
          </div>
          <div className="key">
            <div className="box on"></div>
            <p className="label">Answered</p>
          </div>
        </div>
        <div className="closeBox">
          <FontAwesomeIcon icon={faClose} onClick={() => onToggle(false)} />
        </div>
      </div>
      <div className="questionList">
        {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data?.map((item: any, index: number) => {
          return (
            <div
              className={[
                "question ",
                item.value || item.value === 0 ? "on" : "",
              ].join(", ")}
              key={index}
              onClick={() => gotoTargetedQuestion(item.questionId)}
            >
              {index + 1}
            </div>
          );
        })}
      </div>
      <div className="triangleHolder">
        <img src={`${imagesUrl}downTriangle.svg`} alt="triangle" />
      </div>
    </div>
  );
};

export default FooterQuestionIndex;
